import {styled} from "@mui/material/styles";
import {Paper, Typography, Button} from "@mui/material";
import colors from "../../themes/colors";

export const StyledPaper = styled(Paper)({
  margin: 16,
  borderRadius: 16,
});

export const StyledTitle = styled(Typography)({
  marginLeft: 4,
  fontSize: '1.125rem',
  fontWeight: 400,
});

export const StyledButton = styled(Button)({
  backgroundColor: colors.greenFifth,
  color: colors.white,
  minWidth: 120,
  borderRadius: 24,
  padding: '8px 16px',
  lineHeight: 'unset',
  "&:hover": {
    backgroundColor: colors.greenFifth,
  }
});

export const StyledTitleWarning = styled(Typography)({
  fontSize: '0.875rem',
  fontWeight: 400,
  fontStyle: 'italic',
});

export const StyledTitleStatus = styled(Typography)({
  fontWeight: 400,
});

export const StyledValueStatus = styled(Typography)({
  marginLeft: 4,
  textTransform: 'uppercase',
  fontSize: '0.875rem',
  '&.statusSigned': {
    color: colors.green,
  },
  '&.statusWarning': {
    color: '#f44336',
  }
});
